import { Answer, Score } from "../../multiplechoice/types";
import { Content } from "../types";

export function markAnswer(content: Content, answer: Answer): Score {
  if (!answer) {
    return {
      score: 0
    };
  } else {
    return {
      score: answer.index === content.correctAnswerIndex ? 1 : 0
    };
  }
}
